import { collection, getDocs, query } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { createNewUser, db } from '../firebase';
import { Box, FormControl, Input, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useStoreState } from 'pullstate';
import { AppStore } from '../stores/AppStore';
import { useNavigate } from 'react-router-dom';
const Admin = () => {
    const navigate = useNavigate();
    const { userDoc } = useStoreState(AppStore);
    const [institutions, setInstitutions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedInstitutionId, setSelectedInstitutionId] = useState('');
    const [invitee, setInvitee] = useState({
        name: '',
        email: '',
        credits: 200,
    });

    //get all institutions from firestore collection
    const getInstitutions = async () => {
        const institutionsQuery = query(collection(db, 'institutions'));
        const institutionsSnapshot = await getDocs(institutionsQuery);
        const institutionsList = institutionsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        setInstitutions(institutionsList);
    };

    useEffect(() => {
        getInstitutions();
    }, []);

    const inviteUser = async () => {
        setLoading(true);
        const selectedInstitution = institutions.find((inst) => inst.id === selectedInstitutionId);
        if (!selectedInstitution) {
            console.error('Selected institution not found.');
            setLoading(false);
            return;
        }

        await createNewUser({
            email: invitee.email,
            password: 'abcd1234',
            displayName: invitee.name,
            credits: invitee.credits,
            institutionId: selectedInstitution.id,
            institutionName: selectedInstitution.name,
            institutionLogo: selectedInstitution.logo,
        })
            .then((res) => {
                console.log(res);
                setInvitee({
                    name: '',
                    email: '',
                    credits: 200,
                });
                setSelectedInstitutionId('');
            })
            .catch((err) => {
                console.log(err);
            });
        setLoading(false);
    };

    const resetForm = () => {
        setLoading(true);
        setInvitee({
            name: '',
            email: '',
            credits: 200,
        });
        setSelectedInstitutionId('');
        setLoading(false);
    };

    if (!userDoc.superDuperAdmin) navigate('/'); //redirect to home if not superDuperAdmin
    else
        return (
            <Box>
                <Box
                    sx={{
                        minWidth: '90%',
                        width: '90%',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                    }}
                >
                    <FormControl fullWidth sx={{ width: 300 }}>
                        <InputLabel id='institution-select'>Select Institution</InputLabel>
                        <Select
                            labelId='institution-select'
                            id='institution-select'
                            value={selectedInstitutionId}
                            label='Select Institution'
                            onChange={(e) => setSelectedInstitutionId(e.target.value)}
                        >
                            {institutions.map((institution) => (
                                <MenuItem key={institution.id} value={institution.id}>
                                    {institution.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth sx={{ width: 300 }}>
                        <TextField
                            id='invitee-name'
                            label='Invitee Name'
                            variant='standard'
                            value={invitee.name}
                            onChange={(e) => setInvitee({ ...invitee, name: e.target.value })}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ width: 300 }}>
                        <TextField
                            id='invitee-email'
                            label='Invitee Email'
                            variant='standard'
                            value={invitee.email}
                            onChange={(e) => setInvitee({ ...invitee, email: e.target.value })}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ width: 300 }}>
                        <Input
                            id='invitee-credits'
                            value={invitee.credits}
                            type='number'
                            onChange={(e) =>
                                setInvitee({ ...invitee, credits: parseInt(e.target.value) })
                            }
                        />
                    </FormControl>
                    <LoadingButton loading={loading} variant='contained' onClick={inviteUser}>
                        Invite
                    </LoadingButton>
                    <LoadingButton loading={loading} variant='contained' onClick={resetForm}>
                        Reset
                    </LoadingButton>
                </Box>
            </Box>
        );
};

export default Admin;
